export const unitFaq = {
  head: {
    title: "أسئلة وأجوبة الوحدة",
    chip: "ذكاء اصطناعي",
    subPre: "إجابات تخصّ",
    subStrong: "هذه الوحدة",
    subPost: ". سيستخدمها الوكيل بأولوية عند خدمة ضيف يقيم هنا (مثل رمز بابه، وخصوصيات هذه الشقة…). أرفق صورًا أو مقاطع فيديو وسيرسلها الوكيل عندما يحتاجها الضيف.",
  },
  clone: {
    titleNoun: "الأسئلة الشائعة",
    itemNoun: "الأسئلة الشائعة",
    buttonLabel: "نسخ الأسئلة",
  },

  copyOne: {
    title: "نسخ هذا السؤال",
    itemNoun: "سؤال",
  },
  loading: "جارٍ التحميل…",
  emptyList: "لا توجد أسئلة بعد. أضِف أول سؤال ليعرف الوكيل كيفية الإجابة عنه.",
  list: {
    newQuestion: "سؤال جديد",
    attachments: "{count} مرفق | {count} مرفقات",
    learnedTitle: "مُضافة عبر التعلّم الذاتي",
    deleteTitle: "حذف",
    copyTitle: "النسخ إلى وحدات أخرى",
  },
  form: {
    questionLabel: "السؤال",
    answerLabel: "إجابة الوكيل",
    qPlaceholder: "السؤال · مثال: ما هو رمز الباب؟",
    aPlaceholder: "الإجابة · مثال: رمز مدخل مبناك هو 4512.",
    removeAttachment: "إزالة المرفق",
    uploading: "جارٍ الرفع…",
    attach: "إرفاق",
    addQuestion: "إضافة سؤال",
  },
  preview: {
    tag: "معاينة · WhatsApp",
    online: "متصل",
    aiReception: "الاستقبال بالذكاء الاصطناعي",
    questionPlaceholder: "اكتب سؤال الضيف…",
    answerPlaceholder: "اكتب الإجابة التي سيقدّمها الوكيل…",
    videoFile: "فيديو",
    genericFile: "ملف",
    empty: "اختر سؤالًا أو أنشئ واحدًا لمعرفة كيف سيرد الوكيل.",
    hint: "هكذا سيراها الضيف في محادثته",
  },
  footer: {
    saved: "تم الحفظ",
    save: "حفظ التغييرات",
  },
  errors: {
    load: "تعذّر تحميل الأسئلة.",
    attachNeedsQA: "اكتب السؤال والإجابة قبل إرفاق الملفات.",
    attachNeedsSave: "احفظ أولًا لتتمكن من إرفاق الملفات.",
    upload: "تعذّر رفع الملف.",
    deleteFile: "تعذّر حذف الملف.",
    save: "تعذّر الحفظ.",
  },
};
